export default "__VITE_ASSET__COIP1AN___"